import type { ButtonSize, ButtonVariant } from './Button';

export const base =
  'inline-flex select-none items-center justify-center gap-2 whitespace-nowrap rounded-ui border font-normal ' +
  'transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-60';

/** Ace .btn colours (darkened to AA where needed — see tokens.css). Hover only when enabled. */
export const buttonVariants: Record<ButtonVariant, string> = {
  primary:
    'border-primary bg-primary text-ink-inverse enabled:hover:border-primary-hover enabled:hover:bg-primary-hover',
  secondary: 'border-border-strong bg-surface text-ink enabled:hover:bg-neutral-soft',
  danger:
    'border-danger bg-danger text-ink-inverse enabled:hover:border-danger-hover enabled:hover:bg-danger-hover',
  warning:
    'border-warning bg-warning text-ink enabled:hover:border-warning-hover enabled:hover:bg-warning-hover',
  /** on the dark navbar */
  inverse: 'border-transparent bg-transparent text-ink-inverse enabled:hover:bg-navbar-hover',
  ghost:
    'border-transparent bg-transparent text-link enabled:hover:bg-surface-hover enabled:hover:text-link-hover',
};

export const buttonSizes: Record<ButtonSize, string> = {
  sm: 'min-h-control-sm px-2.5 text-sm',
  md: 'min-h-control px-3 text-base',
};
